// routes/_authenticated/compare.tsx — side-by-side company comparison.
//
// Selection lives in `?cnpjs=` as a comma-separated list of digits-only CNPJs,
// and `?year=` optionally pins the exercise. Both are plain strings/numbers, so
// `stringifySearch` (src/lib/router-search.ts) leaves them alone — an array
// would take the `JSON.stringify` branch and put `%5B%22330…%22%5D` in the URL
// bar of a page whose whole point is being shareable.
import { createFileRoute } from "@tanstack/react-router";

import { ComparePage } from "@/features/compare";

type ParsedSearch = { cnpjs?: string; year?: number };

function parseSearch(input: Record<string, unknown>): ParsedSearch {
  const out: ParsedSearch = {};

  const rawCnpjs = input.cnpjs;
  // Numbers can arrive here: a single unquoted 14-digit CNPJ parses as one.
  if (typeof rawCnpjs === "string" || typeof rawCnpjs === "number") {
    const value = String(rawCnpjs).trim();
    if (value) out.cnpjs = value;
  }

  const year = typeof input.year === "number" ? input.year : Number(input.year);
  if (Number.isFinite(year) && year > 1900) out.year = year;

  return out;
}

export const Route = createFileRoute("/_authenticated/compare")({
  validateSearch: (input: Record<string, unknown>): ParsedSearch => parseSearch(input),
  component: CompareRoute,
});

function CompareRoute() {
  const search = Route.useSearch();
  return <ComparePage year={search.year} />;
}
